import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export function MarketplaceLinkParser({
  children
}) {
  const history = useHistory();
  const ref = useRef(null);
  useEffect(() => {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', e => {
        const match = link.href.match(/^https:\/\/ecosystem\.hubspot(qa)?\.com\/marketplace(.*)$/);
        if (match) {
          e.preventDefault();
          history.push(match[2] || '/');
        }
      });
    });
  }, [history]);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    children: children
  });
}